import * as additional from './additional';
import * as juridical from './juridical';
import * as migration from './migration';

export default {
    additional,
    juridical,
    migration,
};
